module.exports = __webpack_public_path__ + "static/TS-Jesse-bc7db9a0ed60dc892c6a07916848cb01.gif";